import styled from 'styled-components';

export const AddSymbolStyled = styled.div`
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  max-width: 600px;
  & .upload-logo-svg {
    margin: 10px 0px;
  }

  & .browse-files {
    margin-bottom: 30px;
  }
`;
